import { SxProps, Theme } from '@mui/material';
import { commonStyles } from '~/theme/styles/commonStyles';

type TStyles = {
  defaultContainer: SxProps<Theme>;
};

export const styles: TStyles = {
  defaultContainer: (theme: Theme) => ({
    ...(commonStyles.scroll(theme) as Object),
    background: theme.palette.common.white,
    margin: theme.spacing(10),
    maxHeight: '70%',
    maxWidth: '1000px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    outline: 'none',
    gap: theme.spacing(3),
    padding: theme.spacing(5),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(4),
      gap: theme.spacing(1),
    },
  }),
};
